import {
  Button,
  ButtonProps,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
  Tooltip,
} from "@material-ui/core";
import { PropsWithChildren, useState } from "react";
import { useUserDevices } from "../../../graphql/hooks";
import {
  DialogWithActions,
  DialogWithActionsProps,
} from "../dialog_with_actions";
import { LoadWrapper } from "../load_wrapper";
import { PhoneAndroid } from "@material-ui/icons";

export type UserDevicesProps = {
  userId: string;
};
export function UserDevices(props: UserDevicesProps) {
  const { userId } = props;

  const { error, loading, userDevices } = useUserDevices(userId);

  return (
    <List subheader={<ListSubheader>Dispositivi utente</ListSubheader>}>
      <LoadWrapper loading={loading} error={error}>
        {userDevices?.map((device) => (
          <ListItem key={device.id}>
            <ListItemText
              primary={`${device.platform} - ${device.deviceInfo}`}
            />
            <ListItemSecondaryAction>
              {device.currentVersion}
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </LoadWrapper>
    </List>
  );
}

export function UserDevicesWithButtonDialog(
  props: PropsWithChildren<UserDevicesProps> & {
    buttonProps?: Partial<Omit<ButtonProps, "onClick">>;
    dialogProps?: Partial<
      Omit<DialogWithActionsProps, "open" | "setOpen" | "children">
    >;
  }
) {
  const { children, buttonProps, dialogProps, ...userDevicesProps } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <DialogWithActions
        fullScreen={true}
        open={open}
        setOpen={setOpen}
        title={dialogProps?.title ?? "Elenco dispositivi"}
        {...dialogProps}
      >
        <UserDevices {...userDevicesProps} />
      </DialogWithActions>
      <Tooltip title="Dispositivi">
        <IconButton
          aria-label="devices"
          {...props}
          onClick={() => setOpen(true)}
        >
          <PhoneAndroid fontSize="inherit" />
        </IconButton>
      </Tooltip>
      {/* <Button
        variant="contained"
        {...buttonProps}
      >
        {buttonProps?.children}
        {children}
      </Button> */}
    </>
  );
}
